import { h, Component } from 'preact';
import { route, Router } from 'preact-router';
import { connect } from 'redux-zero/preact';
import actions from '../actions';


import Header from './header';
import Login from '../routes/login';
import Home from '../routes/home';
import NotFound from '../routes/404';
import Logout from '../routes/logout';
import Settings from '../routes/settings';
import Entry from './entry';
import Users from '../routes/users';
import Report from '../routes/report';
// import Home from 'async!../routes/home';
// import Profile from 'async!../routes/profile';

const mapToProps = ({ user, agree, isAdmin, settings }) => ({ user, agree, isAdmin, settings });

export class App extends Component {

	state = {
		entryComponent: null
	}

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.setState({
			currentUrl: e.url
		});
	};

	render() {
		const { user, agree, settings } = this.props;
		if (user && agree && this.state.currentUrl === '/') {
			route('/home');
		}
		return (
			<div id="app" style={{
				overflowX: 'hidden'
			}}>
				{ settings && (<Entry ref={entry => {
					this.entryComponent = entry && entry._component._component;
				}} />) }
				{ user && agree && <Header selectedRoute={this.state.currentUrl}  />}
				<Router onChange={this.handleRoute}>
					<Login path="/" />
					<Home path="/home" entryComponent={this.entryComponent} />
					<Logout path="/logout" />
					<Settings path="/ustawienia" />
					<Users path="/uzytkownicy" />
					<Report path="/raport" />
					{/*<NotFound default />*/}
				</Router>
			</div>
		);
	}
}


export default connect(mapToProps, actions)(App);



// WEBPACK FOOTER //
// ./components/app.js